
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DownArrow',

  props: {
    mimeTypeSlag: String
  }
})
